<div id="timeline" class="timeline">
    <!-- power graph -->
    <ce-total-power-graph
        *ngIf="stationId && totalPowerSamples"
        [samples]="totalPowerSamples"
        [reservationSamples]="reservationSamples"
        [seekTime]="seekTime"
        [startTime]="startTime"
        [endTime]="endTime"
        [zoomLevel]="zoomLevel"
        (seekTimeChange)="seekTimeChangeHandler($event)"
        (startTimeChange)="startTimeChangeHandler($event)"
        (endTimeChange)="endTimeChangeHandler($event)"
        (zoomLevelChange)="zoomLevelChangeHandler($event)"
    >
    </ce-total-power-graph>

    <!-- power graph (based on location) -->
    <ce-total-power-graph
        *ngIf="locationUid && totalPowerSamplesLocation"
        [samples]="totalPowerSamplesLocation"
        [seekTime]="seekTime"
        [startTime]="startTime"
        [endTime]="endTime"
        [zoomLevel]="zoomLevel"
        (seekTimeChange)="seekTimeChangeHandler($event)"
        (startTimeChange)="startTimeChangeHandler($event)"
        (endTimeChange)="endTimeChangeHandler($event)"
        (zoomLevelChange)="zoomLevelChangeHandler($event)"
    >
    </ce-total-power-graph>

    <!-- tx timeline -->
    <ce-timeline-chart
        [txs]="txs"
        [connectors]="connectors"
        [connections]="connections"
        [seekTime]="seekTime"
        [startTime]="startTime"
        [endTime]="endTime"
        [bootTimes]="bootTimes"
        (seekTimeChange)="seekTimeChangeHandler($event)"
        (startTimeChange)="startTimeChangeHandler($event)"
        (endTimeChange)="endTimeChangeHandler($event)"
        (zoomLevelChange)="zoomLevelChangeHandler($event)"
        [connectorStatusHistory]="connectorStatusHistory"
        (txClicked)="openTxDetails($event)"
        (connectorLabelClicked)="openConnectorDetails($event)"
    >
    </ce-timeline-chart>
</div>
